import React from "react";
import { Tag } from "primereact/tag";
import "./ProductDetails.css";

/* ── Helpers ─────────────────────────────────────────────────── */
const STATUS_SEVERITY = {
  INSTOCK:    "success",
  LOWSTOCK:   "warning",
  OUTOFSTOCK: "danger",
  PREORDER:   "info",
  BACKORDER:  "help",
};

const STATUS_LABEL = {
  INSTOCK:     "In Stock",
  LOWSTOCK:    "Pocas unidades",
  OUTOFSTOCK:  "Agotado",
  PREORDER:    "Pre-Order",
  BACKORDER:   "Backorder",
  ORDERCLOSED: "Pedido cerrado",
};

/* ── Sub-componente: fila de dato ────────────────────────────── */
function DetailRow({ label, value }) {
  if (!value || value === "—") return null;
  return (
    <div className="pd-row">
      <span className="pd-row__label">{label}</span>
      <span className="pd-row__value">{value}</span>
    </div>
  );
}

/* ── Componente principal ────────────────────────────────────── */
export function ProductDetails({ product }) {
  if (!product) {
    return (
      <div className="pd-empty">
        <i className="pi pi-info-circle pd-empty__icon" />
        <p>No se encontró información del producto.</p>
      </div>
    );
  }

  const data      = product.data ?? product;
  const productId = product.productId ?? data?.id;

  if (!productId) {
    return (
      <div className="pd-empty">
        <i className="pi pi-exclamation-triangle pd-empty__icon" />
        <p>ID de producto inválido o faltante.</p>
      </div>
    );
  }

  const status = data.status;
  const severity = STATUS_SEVERITY[status] || null;
  const label = STATUS_LABEL[status] || status || "—";
  const discount = Number(data.sale_discount || 0);
  const hasDiscount = discount > 0;
  const finalPrice = hasDiscount
    ? Number(data.cost) - (Number(data.cost) * discount) / 100
    : Number(data.cost || 0);

  return (
    <div className="pd">
      
      {/* ── Nombre + precio ─────────────────────────────────── */}
      <div className="pd-header">
        <div className="pd-header__title-wrap">
          <h1 className="pd-header__name">{data.name}</h1>

        </div>
        <p className="pd-header__price">
          {hasDiscount ? (
            <>
              <span className="shop-product_details__old-price">${data.cost}</span>
              <span className="shop-product_details__price--discount">
                ${finalPrice.toFixed(2)}
              </span>
            </>
          ) : (
            `$${data.cost ?? "—"}`
          )}
          <span>MXN</span>
        </p>
      </div>

      {/* ── Badges de estado ────────────────────────────────── */}
      <div className="pd-badges">
        {status && (
          <Tag value={label} severity={severity} className="pd-badge pd-badge--status" />
        )}
        {data.condition && (
          <Tag value={data.condition} severity="info" className="pd-badge" />
        )}
        {hasDiscount && (
          <Tag value={`-${discount}%`} severity="danger" className="pd-badge pd-badge--discount" />
        )}
      </div>

      <div className="pd-divider" />

      {/* ── Datos principales ───────────────────────────────── */}
      <div className="pd-grid">
        <DetailRow label="Marca"               value={data.brand}        />
        <DetailRow label="Categoría"           value={data.category}     />
        <DetailRow label="Serie"               value={data.serie}        />
        <DetailRow label="Fecha de lanzamiento" value={data.release_date} />
      </div>

      <div className="pd-divider" />

      {/* ── Descripción ─────────────────────────────────────── */}
      {data.description && (
        <div className="pd-description">
          <p className="pd-description__label">Descripción</p>
          <p className="pd-description__text">{data.description}</p>
        </div>
      )}

      {/* ── Tags ────────────────────────────────────────────── */}
      {Array.isArray(data.tags) && data.tags.length > 0 && (
        <>
          <div className="pd-divider" />
          <div className="pd-tags">
            <p className="pd-tags__label">Tags</p>
            <div className="pd-tags__list">
              {data.tags.map((tag) => (
                <Tag key={tag} value={tag} className="pd-tag" />
              ))}
            </div>
          </div>
        </>
      )}

      {/* ── Aviso de contacto ───────────────────────────────── */}
      <div className="pd-divider" />
      <div className="pd-contact">
        <i className="pi pi-whatsapp pd-contact__icon" />
        <p className="pd-contact__text">
          ¿Dudas o quieres apartar este producto?{" "}
          <a
            href="https://wa.me/message/CJH5F4NQS6PNN1"
            target="_blank"
            rel="noopener noreferrer"
            className="pd-contact__link"
          >
            Contáctanos por WhatsApp
          </a>
        </p>
      </div>

    </div>
  );
}
